import { Col, Dropdown, Modal, Table, Tag, Typography } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  EllipsisOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { useQueryClient } from "react-query";
import endPoints from "../EndPoints";
import { ItemType } from "antd/es/menu/interface";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { deleteContract } from "../Services";
import { useGetContracts } from "../ServerSideStates";

const { Text } = Typography;

const ListItems = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const columns = [
    {
      title: "Mülk Sahibi Bilgileri",

      render: (_: string, record: any) => {
        return (
          <>
            <div className="">
              <Text
                className="mobile-label"
                data-label="Mülk Sahibi Bilgileri"
              ></Text>
              <div>
                <Text>{record?.ownerName || ""}</Text>
              </div>
              <div>
                <Text>{record?.ownerTCNo || ""}</Text>
              </div>
            </div>
          </>
        );
      },
    },

    {
      title: "Kiracı Sahibi Bilgileri",

      render: (text: string, record: any) => {
        return (
          <>
            <div className="">
              <Text
                className="mobile-label"
                data-label="Kiracı Sahibi Bilgileri"
              ></Text>
              <div>
                <Text>{record?.tenantName || ""}</Text>
              </div>
              <div>
                <Text>{record?.tenantTCNo || ""}</Text>
              </div>
            </div>
          </>
        );
      },
    },
    {
      title: "Danışman Bilgileri",

      render: (text: string, record: any) => {
        return (
          <div className="">
            <Text
              className="mobile-label"
              data-label="Danışman Bilgileri"
            ></Text>
            <div>
              <Text>{record?.advisorName || ""}</Text>
            </div>
            <div>
              <Text>{record?.advisorTCNo || ""}</Text>
            </div>
          </div>
        );
      },
    },

    {
      title: "Başlangıç ve Bitiş Tarihi",

      render: (text: string, record: any) => {
        return (
          <div className="">
            <Text
              className="mobile-label"
              data-label="Başlangıç ve Bitiş Tarihi"
            ></Text>
            {record?.startDate && (
              <div>
                <Text>{dayjs(record?.startDate).format("DD.MM.YYYY")}</Text>
              </div>
            )}
            {record?.endDate && (
              <div>
                <Text>{dayjs(record?.endDate).format("DD.MM.YYYY")}</Text>
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "Ödeme Şekli",
      dataIndex: "paymentType",
      key: "paymentType",
      render: (type: number) => {
        return (
          <Col xs={24} className="!flex !flex-col gap-2 md:!block">
            <Text className="mobile-label" data-label="Ödeme Şekli"></Text>
            <span>
              <Tag color={type === 0 ? "blue" : type === 1 ? "green" : "gold"}>
                {type === 0
                  ? "Peşin"
                  : type === 1
                  ? "Taksit"
                  : "Sözleşmede Belirtildiği Şekilde"}
              </Tag>
            </span>
          </Col>
        );
      },
    },
    {
      title: "Aylık Ödeme",
      dataIndex: "monthlyRentalFee",
      key: "monthlyRentalFee",
      render: (text: string) => (
        <Text className="mobile-label" data-label="Aylık Ödeme">
          {text}
        </Text>
      ),
    },

    {
      title: "",
      dataIndex: "edit",
      key: "edit",
      width: "8%",
      render: (key: any, record: any) => (
        <Col className="text-end pr-2">
          <Dropdown menu={{ items: tableItemDropdownMenu(record) }}>
          <EllipsisOutlined/>
          </Dropdown>
        </Col>
      ),
    },
  ];

  const tableItemDropdownMenu = (record: any): ItemType[] => [
    {
      key: "1",
      onClick: async () => {
        navigate(
          `/admin/panel/sozlesme-ekle-guncelle?contractId=${record?.id}`
        );
      },
      icon: <EditOutlined />,
      label: "Güncelle",
    },
    {
      key: "2",
      onClick: () => {
        confirm(record);
      },
      icon: <DeleteOutlined />,
      label: "Sil",
    },
  ];
  const confirm = (record: any) => {
    Modal.confirm({
      title: "Uyarı",
      icon: <ExclamationCircleOutlined />,
      content: `Bu öğe silinecek. Onaylıyor musunuz?`,
      okText: "Sil",
      cancelText: "Vazgeç",
      onOk: async () => {
        try {
          await deleteContract(record);
          openNotificationWithIcon("default", "İşlem Başarılı");
          queryClient.resetQueries({
            queryKey: endPoints.getContractList,
            exact: false,
          });
        } catch (error: any) {
          openNotificationWithIcon("default", error?.message);
        }
      },
    });
  };

  const contracts = useGetContracts();

  return (
    <Table
      columns={columns}
      dataSource={contracts?.data?.data?.data || []}
      loading={contracts.isLoading || contracts.isFetching}
      rowKey={"id"}
      pagination={{
        position: ["bottomRight"],
        className: "!px-0",
        // onChange: handleChangePagination,
        total: contracts?.data?.data?.length || 0,

        pageSize: 20,
        showLessItems: true,
        size: "small",
        showSizeChanger: true,
        locale: { items_per_page: "" },
        showTotal: (e) => `${e}`,
      }}
    />
  );
};

export default ListItems;
